export enum IndirectRateType {
  Target = "TARGET",
  Actual = "ACTUAL",
  Forecast = "FORECAST",
  Provisional = "PROVISIONAL",
  Initial = "INITIAL"
}
